import ZoneMasterScreen from "components/modules/zone-module/ZoneMasterScreen";
import RegionMasterScreen from "components/modules/region-module/RegionMasterScreen";
import AreaMasterScreen from "components/modules/area-module/AreaMasterScreen";
import BranchMasterScreen from "components/modules/branch-module/BranchMasterScreen";
import ProductMasterScreen from "components/modules/product-module/ProductMasterScreen";
import ActionTypeMasterScreen from "components/modules/action-type-module/ActionTypeMasterScreen";
import ClosureReasonMasterScreen from "components/modules/closure-reason-module/ClosureReasonMasterScreen";
import ProceedingTypeMasterScreen from "components/modules/proceeding-type-module/ProceedingTypeMasterScreen";
import NoticeTypeMasterScreen from "components/modules/notice-type-module/NoticeTypeMasterScreen";
import NoticeReturnStatusMasterScreen from "components/modules/notice-return-status-module/NoticeReturnStatusMasterScreen";
import ExpenseTypeMasterScreen from "components/modules/expense-type-module/ExpenseTypeMasterScreen";
import CourtPlaceMasterScreen from "components/modules/court-place-module/CourtPlaceMasterScreen";
import CourtMasterScreen from "components/modules/court-module/CourtMasterScreen";
import CourtTypeMasterScreen from "components/modules/court-type-module/CourtTypeMasterScreen";
import ArbitratorMasterScreen from "components/modules/arbitrator-module/ArbitratorMasterScreen";
import AdvocateMasterScreen from "components/modules/advocate-module/AdvocateMasterScreen";
import NoticeTemplateMasterScreen from "components/modules/notice-template-module/NoticeTemplateMasterScreen";
import CaseNumberFormatMasterScreen from "components/modules/case-number-format-module/CaseNumberFormatMasterScreen";
import ConfigSettingsScreen from "components/modules/config-module/ConfigSettingsScreen";
import RoleMasterScreen from "components/modules/role-module/RoleMasterScreen";
import CaseTypeMasterScreen from "components/modules/case-type-module/CaseTypeMasterScreen";
import PreLitigationPoolScreen from "components/modules/pre-litigation-module/PreLitigationPoolScreen";
import LitigationCasesScreen from "components/modules/litigation-module/LitigationCasesScreen";
import LitigationCasesPageScreen from "components/modules/litigation-module/LitigationCasesPageScreen";
import RecoveryCasesScreen from "components/modules/recovery-module/RecoveryCasesScreen";
import RecoveryOfficerDashboardScreen from "components/modules/dashboard/RecoveryOfficerDashboardScreen";
import ExecutiveDashboardScreen from "components/modules/dashboard/ExecutiveDashboardScreen";
import EligibilityCriteriaMasterScreen from "components/modules/eligibility-criteria-module/EligibilityCriteriaMasterScreen";
import CaseGroupMasterScreen from "components/modules/case-group-module/CaseGroupMasterScreen";
import ExpenseMasterScreen from "components/modules/expense-module/ExpenseMasterScreen";
import PreLitigationCasesScreen from "components/modules/pre-litigation-module/PreLitigationCasesScreen";
import ClosedCasesReviewScreen from "components/modules/pre-litigation-module/ClosedCasesReviewScreen";
import ReceiptsScreen from "components/modules/pre-litigation-module/ReceiptsScreen";
import AccountCasesScreen from "components/modules/pre-litigation-module/AccountCasesScreen";
import { WorkflowDefinitionsScreen, ApprovalInboxScreen } from "recsuit-workflow";

// Convention (matches prima): every component is registered under its PascalCase
// class name. TenantHub menus MUST set `primaryScreenCode` to this exact string
// (e.g. `primaryScreenCode = "ZoneMasterScreen"`) so the resolver at
// main_layout.tsx finds the component via `COMPONENT_REGISTRY[primaryScreenCode]`.
export const COMPONENT_REGISTRY: Record<string, React.ComponentType<any>> = {
  // ================ Master Data ================
  ZoneMasterScreen: ZoneMasterScreen,
  RegionMasterScreen: RegionMasterScreen,
  AreaMasterScreen: AreaMasterScreen,
  BranchMasterScreen: BranchMasterScreen,

  // ================ Catalogs (Phase 2) ================
  ProductMasterScreen: ProductMasterScreen,
  ActionTypeMasterScreen: ActionTypeMasterScreen,
  ClosureReasonMasterScreen: ClosureReasonMasterScreen,
  ProceedingTypeMasterScreen: ProceedingTypeMasterScreen,
  NoticeTypeMasterScreen: NoticeTypeMasterScreen,
  NoticeReturnStatusMasterScreen: NoticeReturnStatusMasterScreen,
  ExpenseTypeMasterScreen: ExpenseTypeMasterScreen,
  CourtPlaceMasterScreen: CourtPlaceMasterScreen,
  CourtMasterScreen: CourtMasterScreen,
  CourtTypeMasterScreen: CourtTypeMasterScreen,
  ArbitratorMasterScreen: ArbitratorMasterScreen,
  AdvocateMasterScreen: AdvocateMasterScreen,
  NoticeTemplateMasterScreen: NoticeTemplateMasterScreen,

  // ================ Configuration (Phase 3) ================
  ConfigSettingsScreen: ConfigSettingsScreen,
  CaseNumberFormatMasterScreen: CaseNumberFormatMasterScreen,

  // ================ Administration (Phase 4) ================
  RoleMasterScreen: RoleMasterScreen,

  // ================ Case Type registry (Phase 8a) ================
  CaseTypeMasterScreen: CaseTypeMasterScreen,

  // ================ Pre-Litigation (Phase 7) ================
  PreLitigationPoolScreen: PreLitigationPoolScreen,
  PreLitigationCasesScreen: PreLitigationCasesScreen,
  ClosedCasesReviewScreen: ClosedCasesReviewScreen,
  ReceiptsScreen: ReceiptsScreen,
  AccountCasesScreen: AccountCasesScreen,

  // ================ Litigation (Phase 9a) ================
  LitigationCasesScreen: LitigationCasesScreen,

  // ================ Category-scoped Cases (Phase M) ================
  RecoveryCasesScreen: RecoveryCasesScreen,
  LitigationCasesPageScreen: LitigationCasesPageScreen,

  // ================ Recovery Officer Dashboard (Phase 8.D) ================
  RecoveryOfficerDashboardScreen: RecoveryOfficerDashboardScreen,
  ExecutiveDashboardScreen: ExecutiveDashboardScreen,

  // ================ Eligibility Criteria Master (Phase E) ================
  EligibilityCriteriaMasterScreen: EligibilityCriteriaMasterScreen,

  // ================ Case Group / Batch Proceedings (Phase A) ================
  CaseGroupMasterScreen: CaseGroupMasterScreen,

  // ================ Litigation Expense Vouchers (Phase G) ================
  ExpenseMasterScreen: ExpenseMasterScreen,

  // ================ Workflow Framework (Phase 6c) ================
  WorkflowDefinitionsScreen: WorkflowDefinitionsScreen,
  ApprovalInboxScreen: ApprovalInboxScreen,
};